
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Button, TableFooter, TablePagination, Box, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper } from "@mui/material";

import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import MoveUpIcon from '@mui/icons-material/MoveUp';

import { AlertFirmaElectronica } from "../../../components/AlertFirmaElectronica";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { Layout } from "../../../components/Layout";

import { TablePaginationActions } from "../../../helpers/TablePaginationActions";

import { usePages } from "../../../hooks/usePages";

import { setReducerLoading } from "../../../store/slices/LoadingSlice";
import { setReducerBandeja } from "../../../store/slices/BandejaReducer";

import { RootState } from "../../../store";

import { TableTheadStyle, TablePaddingStyle } from "../../../styles/TableStyle";
import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { AsignarActividad, MostrarInbox } from "../../../connections/comun/InboxConnection";

import { InboxProps } from "../../../interfaces/comun/InboxInterface";

const defaultInbox: InboxProps = { numeroSeguimiento: '', proceso: '', tipoTramite: '', actividad: '', path: '', fecha: '', referencia: '', noReferencia: '', folioBuzonElectronico: '', provieneBuzonElectronico: false, delegado: false, usuarioDelegado: false, };

export const InboxPage = () => {  

    const navigate = useNavigate(); 

    const dispatch = useDispatch();

    const { sistemaTurnos } = useSelector( ( state: RootState ) => state.auth );
    const { open } = useSelector( ( state: RootState ) => state.loading );
    const { open: openBandeja } = useSelector( ( state: RootState ) => state.bandeja );

    const [rows, setRows] = useState<InboxProps[]>( [] );

    const [caso, setCaso] = useState<InboxProps>( defaultInbox );
    const [openConfirmacion, setOpenConfirmacion] = useState( false );
    const [loadingAsignar, setLoadingAsignar] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages(10);

    const handleAsignarActividad = async () => {

        setLoadingAsignar( true );

        const { numeroSeguimiento, path } = caso

        await AsignarActividad({ numeroSeguimiento }).then( resp => {

            const { success  } = resp;    

            if( success ){

                setTimeout(() => {

                    setLoadingAsignar( false );
                    setOpenConfirmacion( false );

                    navigate( path );
                    
                }, 700);

            }
            else{
                setLoadingAsignar( false );
            }    

        });

    }

    useEffect(() => {

        async function Obtener(){
            
            dispatch( setReducerLoading( { open: true } ) );

            await MostrarInbox().then( resp => {              
                        
                setTimeout(() => {
    
                    setRows( resp );
                    dispatch( setReducerLoading( { open: false } ) );

                }, 700);   

            });

        }     
        
        Obtener();     

    }, [ dispatch ])    

    useEffect(() => {

        async function Obtener(){
            
            dispatch( setReducerLoading( { open: true } ) );

            await MostrarInbox().then( resp => {              
                        
                setTimeout(() => {
    
                    setRows( resp );
                    dispatch( setReducerLoading( { open: false } ) );
                    dispatch( setReducerBandeja({ open: false }) ); 

                }, 700);   

            });

        }   
        
        if( openBandeja ){
            Obtener();     
        }

    }, [ dispatch, openBandeja ]) 
     
    return (

        <Layout breadcrumbs={[ { text: 'Bandeja' } ]} backgroundPaper={ false } optionTurno={ sistemaTurnos !== 0 }>                  

            {
                open
                ?
                    <Box sx={{ textAlign: 'center', alignItems: 'center', minHeight: 500 }}>
                        <CircularProgressIndicator mt={25} />
                    </Box>
                :
                    <>

                        <AlertFirmaElectronica /> 

                        <TableContainer sx={{ borderRadius: 3 }} component={ Paper }>
                        
                            <Table sx={{ minHeight: rows.length === 0 ? 500 : 0 }}>

                                <TableHead sx={{ ...TableTheadStyle }}>

                                    <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'center' }}>Número de <br /> seguimiento</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Proceso</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Actividad</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}>Fecha</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}>Referencia</TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}></TableCell>
                                        <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%', fontWeight: 'bold' }}></TableCell>
                                                                                
                                    </TableRow>

                                </TableHead>

                                <TableBody>

                                    {
                                        (
                                            rowsPerPage > 0
                                            ?
                                                rows.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                            :
                                                rows
                                        ).map( ( row, index ) => (

                                            <TableRow key={ index } >

                                                <TableCell sx={{ textAlign: 'center', fontWeight: 'Bold' }} > { row.numeroSeguimiento } </TableCell>
                                                
                                                <TableCell> 
                                                    <strong style={{ fontSize: 15 }}>{  row.proceso } </strong> <br />
                                                    <small style={{ fontSize: 13 }}> { row.tipoTramite && " (" + row.tipoTramite + ")" } </small>
                                                </TableCell>
                                                
                                                <TableCell>                                                    
                                                                                                     
                                                    <Button 
                                                        variant='contained'
                                                        size='small'
                                                        sx={{ textAlign: 'left', textTransform: 'none' }}
                                                        onClick={() => {

                                                            if( row.delegado ){ 
                                                                setCaso( row );
                                                                setOpenConfirmacion( true );
                                                            } 
                                                            else { 
                                                                navigate( row.path );
                                                            }

                                                        }}       
                                                        startIcon={ <BusinessCenterIcon /> }  
                                                    >
                                                        { row.actividad } 
                                                    </Button>  
                                                   
                                                </TableCell>                             

                                                <TableCell> { row.fecha } </TableCell>                                    
                                                                
                                                <TableCell> 
                                                    {
                                                        ( row.noReferencia && row.referencia )
                                                        ?                                          
                                                            <>
                                                                <Typography fontWeight={'bold'} fontSize={14}>{ row.referencia }</Typography>
                                                                <Typography fontSize={12} mt={1}>{ row.noReferencia }</Typography>                                                        
                                                            </>
                                                        :
                                                            row.noReferencia && !row.referencia
                                                            ?        
                                                                <Typography fontWeight={'bold'} fontSize={14}>{ row.noReferencia }</Typography>        
                                                            :
                                                                <Typography fontWeight={'bold'} fontSize={14}>{ row.referencia }</Typography>                                                        
                                                    }   
                                                </TableCell>     

                                                <TableCell sx={{ textAlign: 'center' }}>  

                                                    {
                                                        row?.provieneBuzonElectronico
                                                        &&
                                                            <Chip
                                                                variant='outlined'   
                                                                color="secondary"
                                                                sx={{ p: 2 }}
                                                                icon={ <ForwardToInboxIcon fontSize="small" /> }
                                                                label={ 
                                                                    <Typography variant="button" fontWeight={'600'} sx={{ ml: 1 }}> 
                                                                        { row?.folioBuzonElectronico } 
                                                                    </Typography> 
                                                                }
                                                            />
                                                    } 

                                                </TableCell>                                                           

                                                <TableCell sx={{ textAlign: 'center' }}>  

                                                    { row.delegado && <MoveUpIcon sx={{ ml: 2, marginTop: '5px' }} /> }                                    
                                                      
                                                </TableCell>                                                           

                                            </TableRow>

                                        ))
                                    }

                                    {
                                        rows.length === 0 && 
                                        (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={7}
                                                    align="center"                            
                                                >
                                                    <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }

                                </TableBody>

                                <TableFooter>                            

                                    <TableRow>
                                    
                                        <TableCell colSpan={2}>
                                            <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de registros: { rows.length } </Typography>
                                        </TableCell> 
                                    
                                        <TablePagination 
                                            colSpan={7}
                                            rowsPerPageOptions={[ 5, 10, 15, 25, 50, 100 ]}
                                            count={ rows.length }
                                            rowsPerPage={ rowsPerPage }
                                            page={ page }
                                            onPageChange={ handleChangePage }
                                            onRowsPerPageChange={ handleChangeRowsPerPage }

                                            ActionsComponent={ TablePaginationActions }

                                            labelRowsPerPage="Filas por página"                                            
                                            labelDisplayedRows={
                                                ({ from, to, count }) => {
                                                return '' + from + '-' + to + ' de ' + count
                                                }
                                            }                                                                                       
                                        />
                                    </TableRow>

                                </TableFooter>

                            </Table>
                            
                        </TableContainer>       

                        <Dialog open={ openConfirmacion } onClose={ () => {} } >
                                
                            <DialogTitle>
                                Confirmación
                            </DialogTitle>
                            
                            <DialogContent sx={ DialogContentStyle }>
                            
                                <DialogContentText>
                                    ¿Desea asignar la actividad <strong>{ caso?.actividad ?? '' } ({ caso.numeroSeguimiento }) </strong> de <strong>{ caso?.usuarioDelegado ?? '' }</strong> a su cuenta?
                                </DialogContentText>
                            
                            </DialogContent>

                            <DialogActions sx={ DialogActionsStyle }>
                                <Button color="secondary" disabled={ loadingAsignar } onClick={ () => setOpenConfirmacion( false ) }> Cancelar </Button>

                                <Button 
                                    onClick={ handleAsignarActividad } 
                                    variant='contained' 
                                    loading={ loadingAsignar }
                                > 
                                    Aceptar 
                                </Button>

                            </DialogActions>

                        </Dialog>                 
                        
                    </>
            }

        </Layout>  
    )
}
